import { render, staticRenderFns } from "./FormThongBao.vue?vue&type=template&id=26467bed&scoped=true&"
import script from "./FormThongBao.vue?vue&type=script&lang=js&"
export * from "./FormThongBao.vue?vue&type=script&lang=js&"
import style0 from "./FormThongBao.vue?vue&type=style&index=0&id=26467bed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26467bed",
  null
  
)

export default component.exports